<template>
  <v-app>
    <app-bar-component/>
    <alert-component/>
    <v-main>
      <v-container class="fill-height pa-0" fluid>
        <transition
            enter-active-class="transition-ease-in-out"
            leave-active-class="transition-ease-in-out">
          <router-view></router-view>
        </transition>
      </v-container>
    </v-main>
    <v-navigation-drawer
        v-model="show"
        width="310"
        right
        dark
        fixed
        temporary>
      <sidenav-component/>
    </v-navigation-drawer>
    <loading-page-component/>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
    }
  },
  computed: {
    show: {
      get() {
        return this.$store.getters.GET_DRAWER;
      },
      set(value) {
        this.$store.dispatch('setDrawer', value);
      }
    }
  }
};
</script>
